import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CAPITALIZE } from "../../../utils/constants";

export default function DiscountModal({
  open,
  onClose,
  formData,
  setFormData,
  handleChange,
}) {
  const handleReset = () => {
    setFormData((preValue) => ({
      ...preValue,
      discount: {
        discountType: "Percentage",
        discountAmount: 0,
        discountPercentage: 0,
        discountReason: "",
        approvedBy: "",
      },
    }));
    onClose();
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            Discount Details
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Discount Reason"
                name="discountReason"
                value={formData?.discount?.discountReason || ""}
                onChange={(e) => handleChange(e, "discount")}
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Approved By"
                name="approvedBy"
                value={formData?.discount?.approvedBy || ""}
                onChange={(e) => handleChange(e, "discount")}
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Autocomplete
                options={["Percentage", "Amount"]}
                getOptionLabel={(option) => CAPITALIZE(option) || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Discount Type" fullWidth />
                )}
                value={formData?.discount?.discountType || null}
                onChange={(_, newValue) =>
                  handleChange(
                    {
                      target: { name: "discountType", value: newValue },
                    },
                    "discount"
                  )
                }
                sx={{ bgcolor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                type="number"
                label={
                  formData?.discount?.discountType === "Percentage"
                    ? "Percentage"
                    : "Amount"
                }
                name={
                  formData?.discount?.discountType === "Percentage"
                    ? "discountPercentage"
                    : "discountAmount"
                }
                value={
                  formData?.discount?.discountType === "Percentage"
                    ? formData?.discount?.discountPercentage || ""
                    : formData?.discount?.discountAmount || ""
                }
                onChange={(e) => handleChange(e, "discount")}
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
                mr: 2,
              }}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
